package com.eladfinish.bible.contest.ui.scaffold

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.ui.components.message.FloatingMessage

@Composable
fun AppSnackbarHost(
    hostState: SnackbarHostState,
    modifier: Modifier = Modifier,
) {
    SnackbarHost(
        hostState = hostState,
        modifier = modifier,
        snackbar = { snackbarData ->
            val visuals = snackbarData.visuals
            val kind = (visuals as? AppSnackbarVisuals)?.kind ?: MessageKind.SNACKBAR

            when (kind) {
                MessageKind.TOAST -> {
                    FloatingMessage(
                        text = visuals.message,
                        modifier = Modifier.padding(bottom = 32.dp),
                    )
                }

                MessageKind.SNACKBAR -> {
                    AppSnackbar(
                        snackbarData = snackbarData,
                        modifier = Modifier.padding(12.dp),
                        textStyle = MaterialTheme.typography.bodyLarge.copy(
                            fontSize = 18.sp,
                            color = Color.White,
                        )
                    )
                }

                MessageKind.LOADING -> {
                    Snackbar(modifier = Modifier.padding(12.dp)) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(14.dp),
                        ) {
                            CircularProgressIndicator(
                                modifier = Modifier.size(22.dp),
                                color = Color.White,
                                strokeWidth = 2.5.dp,
                            )
                            Text(
                                text = visuals.message,
                                style = MaterialTheme.typography.bodyLarge.copy(
                                    fontSize = 18.sp,
                                    color = Color.White,
                                    textAlign = TextAlign.Start,
                                ),
                            )
                        }
                    }
                }
            }
        }
    )
}
